export default "__VITE_ASSET__BIu6zyeN__"